import { render, staticRenderFns } from "./priceUpdateTool.vue?vue&type=template&id=1a90845a&"
import script from "./priceUpdateTool.vue?vue&type=script&lang=js&"
export * from "./priceUpdateTool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports